import { useQuery } from 'data-fetching-client';
import { useCallback, useMemo } from 'react';
import { getDataFetchingClientRequestState } from '../../dataFetchingClient/utils/getDataFetchingClientRequestState';
export function useCollectionsData(query, props) {
  const {
    loading,
    error,
    data,
    previousData
  } = useQuery(query, {
    variables: props
  });
  const requestState = getDataFetchingClientRequestState(error, loading, !!data);
  const collections = useMemo(() => {
    // Using 'any' type here to support the generic CollectionType structure
    const collectionsData = data || previousData;
    if (!collectionsData) {
      return [];
    } else {
      return collectionsData.collections.collections;
    }
  }, [data, previousData]);
  const getCollectionById = useCallback(id => {
    return collections.find(collection => collection.id === id);
  }, [collections]);
  const getCollectionBySlug = useCallback(slug => {
    return collections.find(collection => collection.publishedListing && collection.publishedListing.slug === slug);
  }, [collections]);
  return {
    data: collections,
    getCollectionById,
    getCollectionBySlug,
    requestState
  };
}